import { FieldArrayFieldsProps } from 'redux-form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName, Stack } from '@optimus-web/core';
import SendEmailDialogInputRow from './SendEmailDialogInputRow';

const MAX_EMAIL_FIELDS = 5;

interface EmailFieldsProps {
    fields: FieldArrayFieldsProps<{ value: string } | null>;
}

const SendDialogEmailFields = ({ fields }: EmailFieldsProps) => (
    <>
        {fields.map((name, index) => (
            <Stack fill vertical spacing="100" key={name}>
                <SendEmailDialogInputRow name={`${name}.value`} onClose={() => fields.remove(index)} />
            </Stack>
        ))}
        <Stack fill alignment="start">
            <Button
                variant="tertiary"
                disabled={fields.length >= MAX_EMAIL_FIELDS}
                icon={IconName.Add}
                onClick={() => fields.push(null)}
                data-add-email-button
                type="submit"
            >
                <LocalizedText textKey={TextKey.Add} />
            </Button>
        </Stack>
    </>
);

export default SendDialogEmailFields;
